import React, { useEffect, useState } from 'react';

import { Typography, notification, Card, Divider, Button, Row, Col, Space } from 'antd';
import { EllipsisOutlined, CaretLeftOutlined } from '@ant-design/icons';

import { FormattedMessage, useIntl } from 'react-intl';

import _service from '@netuno/service-client';

import ToConsumeModal from './Modal';

const langContext = 'reserved-area.marketplace';

const { Meta } = Card;
const { Text } = Typography;

export default ({ wasteTypeUID, radius, setShowMarketplaceWasteType }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalUID, setModalUID] = useState(null);
    useEffect(() => {
        setLoading(true);
        _service({
            method: 'GET',
            url: '/marketplace/waste/consume/list',
            data: {
                waste_type_uid: wasteTypeUID,
                radius: radius
            },
            success: (response) => {
                setData(response.json);
                setLoading(false);
            },
            fail: (e) => {
                setLoading(false);
                notification['error']({
                    message: 'Não foi possivel carregar os dados.',
                    description: e.response.json.error,
                });
            }
        });
    }, []);

    const intl = useIntl();

    const onShowModal = (item) => {
        setIsModalVisible(true);
        setModalUID(item.uid);
    }

    const onModalClose = () => {
        setIsModalVisible(false);
    }

    return (
        <div className='marketplace__waste__type__card'>
            <Button
                title="Voltar"
                className="back-button"
                type="link"
                onClick={() => setShowMarketplaceWasteType(true)}
            ><CaretLeftOutlined /><FormattedMessage id={`${langContext}.button.back`} /></Button>
            <Row gutter={16, 16} justify="start">
                {data.map((item) => (
                    <Space size={[8, 16]} wrap>
                        <Col xs={20} sm={4} md={8} lg={8} xl={{ span: 6, offset: 1 }}>
                            <Card
                                style={{ width: 300 }}
                                actions={[
                                    <Button
                                        title="Detalhes"
                                        className="detail-button"
                                        type="link"
                                        onClick={() => onShowModal(item)}
                                    >
                                        <FormattedMessage id={`${langContext}.button.detail`} />
                                    </Button>,
                                ]}>
                                <Meta
                                    title={item.name}
                                />
                                <Divider />
                                <p>{intl.formatMessage({ id: langContext + '.fields.description' })}: <Text strong>{item.waste_consume.waste_type.description[intl.locale.split('-')[0]]}</Text></p>
                                <p>{intl.formatMessage({ id: langContext + '.fields.amount' })}: <Text strong>{item.waste_consume.amount} {item.waste_consume.measurement_unit.description[intl.locale.split('-')[0]]}</Text></p>
                                <p>{intl.formatMessage({ id: langContext + '.fields.radius' })}: <Text strong>{item.waste_consume.radius} Kms</Text></p>
                                <p>{intl.formatMessage({ id: langContext + '.fields.estimated-date' })}: <Text strong>{item.waste_consume.estimated_date}</Text></p>
                            </Card>

                        </Col>
                    </Space>
                ))}
            </Row>
            {isModalVisible && <ToConsumeModal uid={modalUID} radius={radius} wasteTypeUID={wasteTypeUID} onClose={onModalClose} />}
        </div>
    )
}